import { firestore } from 'firebase/app';
import { PaymentMethod } from '../enums';
import { IFirebaseData } from '../interfaces';
import { Model } from './abstract-model';
import Address from './address';
import { DeliveryMethod, IDeliveryMethodData } from './delivery-method';
import Schedule from './schedule';

class Business extends Model {
  _id: string; // tslint:disable-line variable-name
  active: boolean;
  email: string;
  name: string;
  img: string;
  profilePic: string;
  owner: string;
  address: Address;
  radio: any;
  key: string;
  ruc: string;
  minOrder = 0;
  geolocation: any;
  category?: any;
  categories?: {[category: string]: boolean};
  custom_area: string; // tslint:disable-line variable-name
  polygon_area: any; // tslint:disable-line variable-name
  phone: any;
  /**
   * @deprecated Use `paymentMethods` property instead.
   */
  payment_methods: Array<any> = []; // tslint:disable-line variable-name
  paymentMethods: PaymentMethod = PaymentMethod.None;
  activeCategories: any;

  /**
   * Referencias a los mÃ©todos de entrega disponibles para el negocio.
   */
  deliveryMethodsRefs: firestore.DocumentReference<IDeliveryMethodData>[] = [];

  /**
   * Costos de cada mÃ©todo de entrega.
   */
  costByDeliveryMethod: {
    [deliveryMethodId: string]: number
  } = {};

  timeToAttend: number | undefined;
  pendingOrders: number | undefined;
  totalOrders?: number;
  canDeferOrders = false;
  schedule?: Schedule;

  constructor(data: IFirebaseData = {}) {
    super(data);

    this.deliveryMethodsRefs = data.deliveryMethodsRefs as firestore.DocumentReference<IDeliveryMethodData>[] || [];
    this.costByDeliveryMethod = data.costByDeliveryMethod as { [deliveryMethodId: string]: number} || {};
  }

  /**
   * Obtiene las instancias de los mÃ©todos de entrega disponibles para el negocio.
   */
  async fetchDeliveryMethods() {
    const promises: Promise<firestore.DocumentSnapshot<IDeliveryMethodData>>[] = [];

    this.deliveryMethodsRefs.forEach((ref) => {
      ref.get();
    });

    const results = await Promise.all(promises);

    return results.map((d) => {
      return new DeliveryMethod(d.data(), d.id);
    });
  }
}

export default Business;
